import { render, staticRenderFns } from "./UnitPageCleaner.vue?vue&type=template&id=663ab918&scoped=true"
import script from "./UnitPageCleaner.vue?vue&type=script&lang=js"
export * from "./UnitPageCleaner.vue?vue&type=script&lang=js"
import style0 from "./UnitPageCleaner.vue?vue&type=style&index=0&id=663ab918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ab918",
  null
  
)

export default component.exports